module.exports = "/_next/static/media/2f74fe08ad4b295473a235d3e6516820.svg";